import { hasPermissionGuard } from "../../core/guards";
import { Constants } from "../../shared/constants/constants";
import { PermissionAction } from "../../shared/constants/enums";

export const viewAttributesPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.EXTENDEND_ATTRIBUTES,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const createAttributesPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.create,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.EXTENDEND_ATTRIBUTES,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const manageAttributesPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.manage,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.EXTENDEND_ATTRIBUTES,
        },
      ],
    },
    redirectTo: "/403",
  }),
];
